import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useTransportFiltersStore } from 'shared/stores/use-transport-filters';
import { TransportFiltersDrawer } from './components/transport-filters-drawer';
import { TransportSearch } from './components/transport-search';

export const TransportFilter: React.FC = () => {
  const { filters, search } = useTransportFiltersStore();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <TransportSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <TransportFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
